export default __webpack_public_path__ + "static/media/ducks.142df4a8.png";